import { forwardRef } from 'react'
import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { cn } from '@/lib/utils'

/**
 * Divider — разделитель (Separator) между группами элементов (например, в Sidebar перед «Настройки»).
 * Декоративен по умолчанию; цвет/отступы из токенов.
 */
export const Divider = forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    orientation={orientation}
    decorative={decorative}
    className={cn(
      'bg-line',
      orientation === 'horizontal' ? 'my-2 h-px w-full' : 'mx-2 h-full w-px',
      className,
    )}
    {...props}
  />
))
Divider.displayName = 'Divider'
